/**
 * Get user answer for a question
 */
export const getUserAnswer = (question, userOnboarding, categoryId) => {
  if (!userOnboarding || !question) return null;

  // Preferred key format is questionId only (backend IDs are unique)
  let answer = userOnboarding[question.id];

  // Back-compat: older saved objects used `${categoryId}-${question.id}`
  if ((answer === undefined || answer === null) && categoryId) {
    const legacyKey = `${categoryId}-${question.id}`;
    answer = userOnboarding[legacyKey];
  }

  // Special handling for duration questions with custom values
  if (question.id === 'duration' && answer === 'Enter exact Duration') {
    const customValue = userOnboarding['duration_custom'];
    if (customValue && customValue.trim()) {
      answer = customValue.trim();
    }
  }

  // Handle default values for number questions
  if (question.type === 'number' && (answer === undefined || answer === null)) {
    return question.answer || '0';
  }

  return answer;
};
